export const defaultVacanciesFilterFiedls = {
  customer_id: undefined,
  project_id: undefined,
  recruiter_id: undefined,
  status: undefined,
  created_by: undefined,
  created_at_from: undefined,
  created_at_to: undefined,
  search: undefined,
  limit: undefined,
  offset: undefined,
  sort_column: undefined,
  sort_direction: undefined,
};
